import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Discount } from '@/models/discounts.model';

class DiscountService extends BaseService {
  private url: string = '/api/discount';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Discount>> {
    const res = await this.$http.get<Discount>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: { ...res.data },
    };
  }

  public async getList(): Promise<DataResponse<Discount[]>> {
    const res = await this.$http.get<Discount[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data.map((d) => ({
        ...d,
      })),
    };
  }

  public async create(
    item: Partial<Discount>,
  ): Promise<DataResponse<Discount>> {
    const res = await this.$http.post<Discount>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: Discount): Promise<DataResponse<Discount>> {
    const res = await this.$http.put<Discount>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new DiscountService();
